<template>
  <div class="home-page">
    <!-- 顶部Banner图 -->
    <div class="top-banner">
      <img :src="baseUrl + '/banner1.png'" alt="Banner" class="banner-image" />

      <div class="info">
        <img :src="baseUrl + '/logo2.png'" class="logo" alt="">
        <div class="label">医疗器械注册辅助工具</div>
        <img :src="baseUrl + '/btn.png'" class="btn" alt="">
      </div>
    </div>

    <!-- 搜索区域 - 浮动在banner和main中间 -->
    <div class="search-section">
      <div class="search-container">
        <input
          v-model="keyword"
          type="text"
          class="search-input"
          placeholder="输入关键词搜索相关法规、标准、指导原则"
        />
        <button class="search-button" @click="getList">立即搜索</button>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">

      <!-- 表格区域 -->
      <div class="table-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th class="col-type">文件类型</th>
                <th class="col-name">文件名称</th>
                <th class="col-publisher">发布机构</th>
                <th class="col-time">发布时间</th>
                <th class="col-status">生效状态</th>
                <th class="col-info">信息类型</th>
                <th class="col-link">网页链接</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in tableData" :key="index">
                <td class="col-type">{{ item.file_category }}</td>
                <td class="col-name">{{ item.file_name }}</td>
                <td class="col-publisher">{{ item.medical_file_publish_orgnization }}</td>
                <td class="col-time">{{ item.medical_file_publish_date ? item.medical_file_publish_date.substring(0, 10) : '' }}</td>
                <td class="col-status">{{ item.medical_file_law_status }}</td>
                <td class="col-info">{{ item.regulation_file_type }}</td>
                <td class="col-link">
                  <a :href="item.medical_file_website_link" target="_blank" class="link">{{ item.medical_file_website_link }}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-footer">
          当前显示10条结果，登陆后可查看更多数据，<a href="javascript: void(0)" @click="showMessage" class="more-link">立即登录</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { getLawList } from '@/apis/index'
import { showToast } from 'vant'
import { baseUrl } from '@/utils'
// 表格数据
const tableData = ref([])

const keyword = ref('')

const getList = async () => {
  const res = await getLawList({
    file_category_type: '法规',
    keyword: keyword.value,
    page: 1,
    pageSize: 10,
    search_type: '智能检索'
  })

  console.log(123, res)
  tableData.value = res.result
}

const showMessage = () => {
  showToast({
    message: '联系客服邮箱\nservice@msecu.com',
    position: 'top'
  })
}

onMounted(() => {
  getList()
})

</script>

<style lang="less" scoped>


.home-page {
  min-height: 100vh;
  position: relative;
  padding-bottom: 40px;
}

.top-banner {
  width: 100%;
  height: 600px;
  overflow: hidden;
  .info {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .logo {
      width: 210px;
    }
    .btn {
      width: 244px;
      cursor: pointer;
      transition: all .3s;
      &:hover {
        transform: scale(1.02);
      }
    }
    .label {
      margin: 27px 0 36px;
      font-family: YouSheBiaoTiHei;
      font-size: 80px;
      line-height: 100px;
      color: #101010;
    }
  }
  .banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.search-section {
  position: absolute;
  top: 574px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  z-index: 10;
}

.search-container {
  display: flex;
  justify-content: center;
  gap: 15px;
  max-width: 800px;
  margin: 0 auto;

  .search-input {
    flex: 1;
    padding: 14px 20px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;

    &:focus {
      border-color: #1890ff;
    }
  }

  .search-button {
    padding: 14px 40px;
    background-color: #1890ff;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 4px 8px rgba(24, 144, 255, 0.3);

    &:hover {
      background-color: #096dd9;
      transform: scale(1.02);
      box-shadow: 0 6px 12px rgba(24, 144, 255, 0.4);
    }
  }
}

.main-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  background: white;
}

.table-section {
  margin-top: 60px;
}

.table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  tbody {
    tr {
      &:nth-child(odd) {
        background: #fff;
      }
      &:nth-child(even) {
        background: #f7f7f7;
      }
    }
  }
  th {
    background-color: #f0f8ff;
    padding: 15px;
    text-align: left;
    font-weight: 600;
    color: #333;
    font-size: 16px;
    border-bottom: 1px solid #e8e8e8;
    text-align: center;
    &.col-type {
      width: 100px;
    }

    &.col-name {
      width: auto;
      min-width: 300px;
    }

    &.col-publisher {
      width: 200px;
    }

    &.col-time {
      width: 120px;
    }

    &.col-status {
      width: 100px;
    }

    &.col-info {
      width: 120px;
    }

    &.col-link {
      width: auto;
      min-width: 200px;
    }
  }

  td {
    padding: 12px 15px;
    border-bottom: 1px solid #f0f0f0;
    color: #101010;
    
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;

    &.col-name {
      max-width: 0;
    }

    &.col-link {
      max-width: 0;
    }
  }

  tr {
    &:hover {
      background-color: #f5f5f5;
    }
  }

  .link {
    color: #1890ff;
    text-decoration: none;
    transition: color 0.3s;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      color: #096dd9;
      text-decoration: underline;
    }
  }
}

.table-footer {
  text-align: center;
  padding: 20px 0;
  margin-top: 10px;
  color: #101010;
  
  font-size: 16px;
  text-align: left;
  .more-link {
    color: #1890ff;
    text-decoration: none;
    margin-left: 5px;

    &:hover {
      text-decoration: underline;
    }
  }
}

// 小分比率适配
@media screen and (max-width: 1560px) {
  .main-content {
    max-width: 1200px;
  }
  .top-banner {
    width: 100%;
    height: 520px;
    .info {
      height: 520px;
      .logo {
        width: 180px;
      }
      .btn {
        width: 210px;
      }
      .label {
        margin: 22px 0 30px;
        font-size: 70px;
        line-height: 84px;
      }
    }
  }

  .search-section {
    top: 494px;
  }

  .data-table {
    th, td {
      font-size: 15px;
    }
  }
  .table-footer {
    font-size: 15px;
  }
}
// 小分比率适配
@media screen and (max-width: 1400px) {
  .main-content {
    max-width: 1080px;
  }
  .top-banner {
    width: 100%;
    height: 520px;
    .info {
      height: 520px;
      .logo {
        width: 180px;
      }
      .btn {
        width: 210px;
      }
      .label {
        margin: 22px 0 30px;
        font-size: 70px;
        line-height: 84px;
      }
    }
  }

  .search-section {
    top: 494px;
  }

  .data-table {
    th, td {
      font-size: 14px;
    }
  }
}
</style>